import { get } from "idb-keyval";
import { best_host_key, default_best_host } from "./constants";
import isValidHost from "./isValidHost";

export default async function () {
  const best_host = await get(best_host_key);
  return isValidHost(best_host) ? best_host : default_best_host;
}
